import { useQuery } from '@tanstack/react-query'
import { getMeetingGroup } from '../api/meetingApi'

/** Tekil grup (breadcrumb/başlık — 044). id geçersizse sorgu pasif. */
export function useMeetingGroup(id: number | null) {
  return useQuery({
    queryKey: ['meeting-group', id],
    queryFn: () => getMeetingGroup(id as number),
    enabled: id != null && !Number.isNaN(id),
  })
}
